export default "__VITE_ASSET__Cjr7oyhJ__"